import * as url from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

export default function UserReviewRejectedText({
  actionName = null,
}: {
  actionName?: string | null
} = {}): React.ReactElement {
  return (
    <>
      Thanks for applying to Schoolhouse.world! Your application was flagged for further review.{' '}
      {actionName != null
        ? `You need to finish the application process before you can ${actionName}. `
        : ''}
      To finish the application process, please contact{' '}
      <ShwLink href={url.faq.getArticleUrl('how-do-i-contact-the-schoolhouse-team')}>
        User Support
      </ShwLink>
      and share a few more details about why you want to join Schoolhouse.world and how you plan to
      use it, and our team will get back to you shortly!
    </>
  )
}
